module.exports = __webpack_public_path__ + "../resources/img/normal_process1.6c74f267.png";